import { Accordion, AccordionDetails, AccordionSummary, Box, Button, FormControl, FormControlLabel, InputLabel, MenuItem, Radio, RadioGroup, Select, Tooltip, Typography } from "@mui/material";
import Grid from '@mui/material/Unstable_Grid2';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';


function DriversJourneyPreferences() {

  return (
    <Box display='flex' flexDirection='row' justifyContent='center' sx={{ marginBlockEnd: '0.5rem'}}>
     <Accordion sx={{ width: '100%', boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px;'}}>
        <AccordionSummary
          expandIcon={<ArrowDownwardIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography component="span" variant="h6">Preenchimento das Jornadas pelo Motorista</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Box sx={{ display: 'flex', marginBlock: '1rem'}}>
            <Box sx={{ width: '50%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-start'}}>
                <Typography variant="body1">Pré-preenchimento das jornadas segundo a Folha de Ponto Virtual</Typography>
                <Tooltip title="Open settings" sx={{ marginBlockStart: '0.2rem', marginInlineStart: '0.5rem'}}>
                  <InfoOutlinedIcon fontSize="small" />
                </Tooltip>
              </Box>
            </Box>
            <Box sx={{ margin: '0rem 1rem 0 1rem', width: '50%', display: 'flex', justifyContent: 'flex-start'}}>
              <RadioGroup row defaultValue="true" name="radio-buttons-group">
                    <FormControlLabel control={<Radio />} label="Sim"/>
                    <FormControlLabel control={<Radio />} label="Não"/>
              </RadioGroup>
            </Box>
          </Box>
          <Box sx={{ display: 'flex', marginBlock: '1rem'}}>
            <Box sx={{ width: '50%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-start'}}>
                <Typography variant="body1">Número Mínimo e Máximo de Jornadas a preencher</Typography>
                <Tooltip title="Open settings" sx={{ marginBlockStart: '0.2rem', marginInlineStart: '0.5rem'}}>
                  <InfoOutlinedIcon fontSize="small"/>
                </Tooltip>
              </Box>
            </Box>
            <Box sx={{ margin: '0rem 1rem 0 1rem', width: '50%', display: 'flex', justifyContent: 'flex-start'}}>
              <FormControl size="small" sx={{ minWidth: 180, width: '100%', bgcolor: 'white', marginInlineEnd: '0.1rem' }} fullWidth>
                <InputLabel>Número Mínimo</InputLabel>
                <Select
                    size="small"
                    value={'0'} displayEmpty required={true} label={"Número Mínimo"}>
                    <MenuItem value={'Transol'}>Todos</MenuItem>
                    <MenuItem value={'Cityrama'}>Anabela</MenuItem>
                    <MenuItem value={'Rodest'}>Eunildes</MenuItem>
                </Select>
              </FormControl>
              <FormControl size="small" sx={{ minWidth: 180, width: '100%', bgcolor: 'white', marginInlineStart: '0.1rem' }} fullWidth>
                <InputLabel>Número Máximo</InputLabel>
                <Select
                    size="small"
                    value={'0'} displayEmpty required={true} label={"Número Máximo"}>
                    <MenuItem value={'Transol'}>Todos</MenuItem>
                    <MenuItem value={'Cityrama'}>Anabela</MenuItem>
                    <MenuItem value={'Rodest'}>Eunildes</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </Box>
          <Box sx={{ display: 'flex', marginBlock: '1rem'}}>
            <Box sx={{ width: '50%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-start'}}>
                <Typography variant="body1">Estado pré-definido da conformidade da Limpeza da Viatura no início da primeira jornada.</Typography>
                <Tooltip title="Open settings" sx={{ marginBlockStart: '0.2rem', marginInlineStart: '0.5rem'}}>
                  <InfoOutlinedIcon fontSize="small"/>
                </Tooltip>
              </Box>
            </Box>
            <Box sx={{ margin: '0rem 1rem 0 1rem', width: '50%', display: 'flex', justifyContent: 'flex-start'}}>
              <RadioGroup row defaultValue="true" name="radio-buttons-group">
                    <FormControlLabel control={<Radio />} label="Estado Selecionado: Sim"/>
                    <FormControlLabel control={<Radio />} label="Estado Selecionado: Não"/>
              </RadioGroup>
            </Box>
          </Box>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}

export default DriversJourneyPreferences;